import { AuthFlow } from "./AbstractAuthFlow";
import * as AuthApi from "../../apiLoader/auth";
import { updateSession } from "../../stores/session";

export class GoogleAuthFlow implements AuthFlow {
  async start() {
    updateSession({ isAuthenticating: true });
    const authTokenPromise = new Promise<string>((resolve, reject) => {
      // eslint-disable-next-line
      const googleClient: google.accounts.oauth2.TokenClient = google.accounts.oauth2.initTokenClient({
        client_id: import.meta.env.FOOJI_YOUTUBE_CLIENT_ID as string,
        scope: "https://www.googleapis.com/auth/youtube.readonly",
        callback: (tokenResponse: { access_token: string }) => {
          resolve(tokenResponse.access_token);
        },
        error_callback: (error: Error) => {
          reject(error);
        }
      });
      // eslint-disable-next-line
      googleClient.requestAccessToken();
    });
    try {
      const googleAccessToken = await authTokenPromise;
      const { jwt } = await AuthApi.finishYoutube(googleAccessToken);
      const redirectUri = `${document.location.origin}${document.location.pathname}?jwt=${jwt}`;
      document.location.href = redirectUri;
    } catch (e) {
      updateSession({ isAuthenticating: false });
      throw e;
    }
  }
}
